import serviceDeskService from '@/api/servicedesk'
import {SERVICE_DESK} from '@/store/types'
import utils from '@/utils/utils.js'

export default {
  namespaced: true,
  state: {
    requests: [],
    date: undefined,
    suppliers: [],
    services: [],
    log: null,
    users: []
  },
  getters: {
    services: (state) => {
      return state.services
    }
  },
  mutations: {
    [SERVICE_DESK.SET_SERVICES] (state, services) {
      state.services = services
    },
    [SERVICE_DESK.SET_REQUESTS] (state, result) {
      state.requests = result
    },
    [SERVICE_DESK.SET_SUPPLIERS] (state, suppliers) {
      state.suppliers = suppliers
    },
    [SERVICE_DESK.SET_DATE] (state, date) {
      state.date = date
    },
    [SERVICE_DESK.AUDIT_LOG_SET] (state, log) {
      state.log = log
    },
    [SERVICE_DESK.PUSH_USER] (state, email) {
      state.users.push(email)
    },
    [SERVICE_DESK.REMOVE_USER] (state, index) {
      state.users.splice(index, 1)
    },
    [SERVICE_DESK.SET_USER] (state, user) {
      state.users = user
    }
  },
  actions: {
    async getServicesDesk ({ commit }) {
      try {
        let response = await serviceDeskService.getServicesDesk()
        commit(SERVICE_DESK.SET_SERVICES, response.data)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async getServiceRequests ({state, dispatch, commit, rootGetters}) {
      try {
        dispatch('Global/showLoading', null, { root: true })
        let date = state.date.toISOString()
        let response = await serviceDeskService.getServiceRequests(date)
        for (var event of response.data) {
          let rooms = []
          for (var room of event.rooms) {
            let roomDetails = Object.assign({}, rootGetters['Global/roomMap'][room.roomId])
            roomDetails.rejected = room.rejected
            roomDetails.isApproved = room.isApproved
            roomDetails.eventsNeedApproval = room.eventsNeedApproval
            roomDetails.allowServiceDesk = room.allowServiceDesk
            rooms.push(roomDetails)
          }
          event.rooms = rooms
        }
        commit(SERVICE_DESK.SET_REQUESTS, response.data)
        dispatch('Global/hideLoading', null, { root: true })
      } catch (error) {
        dispatch('Global/hideLoading', null, { root: true })
        return Promise.reject(error)
      }
    },
    async getSuppliers ({commit, dispatch}) {
      try {
        let response = await serviceDeskService.getSuppliers()
        commit(SERVICE_DESK.SET_SUPPLIERS, response.data)
      } catch (error) {
        dispatch('Global/hideLoading', null, { root: true })
        return Promise.reject(error)
      }
    },
    async saveServiceDesk ({ dispatch }, obj) {
      dispatch('Global/showLoading', null, { root: true })
      try {
        await serviceDeskService.saveServicesDesk(obj.serviceDeskRequest, obj.eventId)
        dispatch('getServicesDesk')
      } finally {
        dispatch('Global/hideLoading', null, { root: true })
      }
    },
    async getServiceDeskReport ({dispatch}, params) {
      dispatch('Global/showLoading', null, {root: true})
      try {
        let reportName = `${params.start} - ${params.end}.xlsx`
        let response = await serviceDeskService.getReport(params.start, params.end)
        let contentType = response.headers['content-type']
        let blob = new Blob([response.data], { type: contentType })
        utils.handleDownload(blob, reportName)
      } finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    setDate ({commit}, date) {
      commit(SERVICE_DESK.SET_DATE, date.hour(0).minute(0).second(0))
    },
    async getAuditLogServicesDesk ({ commit, dispatch }, obj) {
      try {
        let response = await serviceDeskService.getAuditLogServicesDesk(obj)
        commit(SERVICE_DESK.AUDIT_LOG_SET, response.data)
      } catch (error) {
        dispatch('Global/hideLoading', null, { root: true })
        return Promise.reject(error)
      }
    },
    async saveSuppliers ({ dispatch }, servicesRequested) {
      dispatch('Global/showLoading', null, { root: true })
      let services = servicesRequested.services.map(service => {
        return {
          serviceId: service.id,
          supplierId: service.supplierId
        }
      })
      try {
        await serviceDeskService.saveSuppliers(services, servicesRequested.extendedPropertiesId)
        dispatch('getServicesDesk')
        dispatch('getServiceRequests')
      } catch (error) {
        dispatch('Global/hideLoading', null, { root: true })
        return Promise.reject(error)
      }
    },
    pushUser ({ state, commit, dispatch }, item) {
      if (state.users.filter(user => user.email === item.email).length === 0) {
        commit(SERVICE_DESK.PUSH_USER, item)
      } else {
        dispatch('Global/showMessage', 'userDuplicated', {root: true})
      }
    },
    removeUser ({ commit }, index) {
      commit(SERVICE_DESK.REMOVE_USER, index)
    },
    clearUsers ({ commit }) {
      commit(SERVICE_DESK.SET_USER, [])
    }
  }
}
